module.exports = __webpack_public_path__ + "static/media/IMG_2977.2acf9d46.jpg";